import React, {FC, useState} from "react"

import FormattedMessage, {useIntl} from "@irati/utils/lang"

import GenericModal from "@irati/ui/src/GenericModal"
import Flex from "@irati/ui/src/Flex"
import {Body, H3} from "@irati/ui/src/Typography"
import UpdateOrdersCSV from "./UpdateOrdersCSV"
import BackLink from "./BackLink"

interface Props {}

const BulkUpdateOrders: FC<Props> = () => {
  const {formatMessage} = useIntl()
  const [showSuccess, setShowSuccess] = useState(false)

  const handleSuccess = () => {
    setShowSuccess(true)
  }

  const handleOnCloseModal = () => {
    setShowSuccess(false)
  }
  return (
    <>
      <BackLink />
      <UpdateOrdersCSV onSuccess={handleSuccess} />
      <GenericModal hideActions show={showSuccess} onHide={handleOnCloseModal}>
        <Flex justifyContent="center" alignItems="center" direction="column">
          <H3 marginBottom={4}>
            <FormattedMessage id="admin.components.updatePeopleCSV.successModal.title" />
          </H3>
          <img height="150px" src={formatMessage({id: "admin.components.updatePeopleCSV.successModal.img"})} alt="updateBulkOrderImg" />
          <Body marginTop={4} maxWidth="100%" weight="semibold" textAlign="center">
            <FormattedMessage id="admin.components.orderManagement.updateOrders.body" />
          </Body>
        </Flex>
      </GenericModal>
    </>
  )
}

export default BulkUpdateOrders
